import { combineReducers } from 'redux';

import commonReducers from '../../common/reducers';
import isPostInPreview from '../../common/store/is-post-in-preview/is-post-in-preview-reducer';
import loadingBar from '../../common/store/loading-bar/loading-bar-reducer';
import postEditor from '../../common/store/post-editor/post-editor-reducer';
import recentPostsIds from '../../recent-posts/reducers/recent-posts-ids';
import lastPostSlug from './last-post-slug';
import pricingPlansUrl from './pricing-plans-url';
import rceSettings from './rce-settings';
import readingSessionId from './reading-session-id';
import relatedPosts from './related-posts';

export const postPageReducers = {
  ...commonReducers,
  isPostInPreview,
  lastPostSlug,
  postEditor,
  rceSettings,
  recentPostsIds,
  relatedPosts,
  loadingBar,
  readingSessionId,
  pricingPlansUrl,
};

export default combineReducers(postPageReducers);
